import { JSX } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { BettingOptionsFormat, formatBettingOption } from '@betgames/bg-tools';
import { SelectListItem } from '@bg-components/Modals/TopSettingsModal/List/SelectListItem';
import { AccordionListItem } from '@bg-components/Modals/TopSettingsModal/List/AccordionListItem';
import {
    t,
    playerSettingsStore,
    playerSettingsSelectors,
    playerSettingsApi,
    analyticsApi,
    partnerSettingsStore,
} from '@bg-shared';
import { ToggleListItem } from '../List/ToggleListItem';
import classes from './CasinoSettings.module.scss';

export const CasinoSettings = (): JSX.Element => {
    const casinoModeEnabled = useStore(playerSettingsStore, playerSettingsSelectors.getCasinoMode);
    const selectedOddsFormat = useStore(playerSettingsStore, playerSettingsSelectors.getOddsFormat);

    return (
        <>
            {!partnerSettingsStore.isLithuaniaJurisdiction && (
                <ToggleListItem
                    label={t.string('casino_mode')}
                    enabled={casinoModeEnabled}
                    dataQa="area-casino-mode-list-item"
                    onChange={(newValue) => {
                        playerSettingsApi.update((store) => {
                            store.casinoMode = newValue;
                        });
                        analyticsApi.trackCasinoSwitch(newValue);
                    }}
                />
            )}
            <AccordionListItem
                disabled={!casinoModeEnabled}
                label={t.string('odds_format')}
                dataQa="area-odds-formats-list-item"
            >
                {Object.values(BettingOptionsFormat).map((format) => (
                    <SelectListItem
                        key={format}
                        dataQa={`area-select-list-item-${format}`}
                        selected={format === selectedOddsFormat}
                        label={t.oddsFormat(format)}
                        onClick={() => {
                            playerSettingsApi.update((store) => {
                                store.oddsFormat = format;
                            });
                            analyticsApi.trackOddsFormatSwitch(format);
                        }}
                    >
                        <span className={classes.formatExample}>
                            {formatBettingOption({
                                value: 18,
                                format,
                                casinoConfig: {
                                    currency: partnerSettingsStore.currency,
                                    text: t.string('pays'),
                                },
                            })}
                        </span>
                    </SelectListItem>
                ))}
            </AccordionListItem>
        </>
    );
};
